/**
 * Event types for pricing and listings.
 * Used in Event Essentials (pricing) and elsewhere.
 */

export interface EventTypeOption {
  id: number;
  event_name: string;
  key_name: string;
  e_slug: string;
}

export const EVENT_TYPES: EventTypeOption[] = [
  { id: 19, event_name: 'Birthday Parties', key_name: 'birthday-parties', e_slug: 'birthday-parties' },
  { id: 1, event_name: 'Campus', key_name: 'campus', e_slug: 'campus' },
  { id: 2, event_name: 'Charity', key_name: 'charity', e_slug: 'charity' },
  { id: 18, event_name: 'Collaboration', key_name: 'collaboration', e_slug: 'collaboration' },
  { id: 3, event_name: 'Concert/Festival', key_name: 'concert_festivals', e_slug: 'concert-festival' },
  { id: 4, event_name: 'Corporate', key_name: 'corporate', e_slug: 'corporate' },
  { id: 17, event_name: 'Endorsement', key_name: 'endorsement', e_slug: 'endorsement' },
  { id: 5, event_name: 'Exhibition', key_name: 'exhibitions', e_slug: 'exhibition' },
  { id: 6, event_name: 'Fashion Show', key_name: 'fashion', e_slug: 'fashion-show' },
  { id: 20, event_name: 'House Party', key_name: 'house-party', e_slug: 'house-party' },
  { id: 7, event_name: 'Inauguration', key_name: 'inaugurations', e_slug: 'inauguration' },
  { id: 8, event_name: 'Kids Party', key_name: 'kid_parties', e_slug: 'kids-party' },
  { id: 9, event_name: 'Photo/Video Shoot', key_name: 'photo_video_shoots', e_slug: 'photo-video-shoot' },
  { id: 10, event_name: 'Private Party', key_name: 'private_parties', e_slug: 'private-party' },
  { id: 11, event_name: 'Professional Hiring', key_name: 'professional_hiring', e_slug: 'professional-hiring' },
  { id: 12, event_name: 'Religious', key_name: 'religious_functions', e_slug: 'religious' },
  { id: 13, event_name: 'Restaurant', key_name: 'restaurants_pubs_bars', e_slug: 'restaurant' },
  { id: 16, event_name: 'Video Shoutout', key_name: 'video_shoutout', e_slug: 'video-shoutout' },
  { id: 15, event_name: 'Virtual', key_name: 'virtual', e_slug: 'virtual' },
  { id: 14, event_name: 'Wedding', key_name: 'weddings', e_slug: 'wedding' },
];
